import { configureStore } from "@reduxjs/toolkit";
import { setupListeners } from "@reduxjs/toolkit/query";
import { billsApi } from "./bills/BillsApiSlice";
import { landingPageApi } from "./invoices/InvoiceApiSlice";
import { authApi } from "./auth/authApiSlice";
import { vendorApi } from "./vendor/VendorApi";
import { captchaApi } from "./captcha/captchaApiSlice";
import { empDataApi } from "./vendor/employeeDataSlice";

export const store = configureStore({
  reducer: {
    [billsApi.reducerPath]: billsApi.reducer,
    [landingPageApi.reducerPath]: landingPageApi.reducer,
    [authApi.reducerPath]: authApi.reducer,
    [vendorApi.reducerPath]: vendorApi.reducer,
    [captchaApi.reducerPath]: captchaApi.reducer,
    [empDataApi.reducerPath]: empDataApi.reducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(billsApi.middleware, landingPageApi.middleware, authApi.middleware, vendorApi.middleware, captchaApi.middleware, empDataApi.middleware),
});

// Setup for RTK Query
setupListeners(store.dispatch);

// Infer RootState and AppDispatch from the store itself
export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
